var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin-logo",
    fill: "#6C757D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9590255,12.2593689 L19.9590255,19.9786408 L15.6811601,19.9786408 L15.6811601,12.7763592 C15.6811601,10.9670874 15.062413,9.7323301 13.5139675,9.7323301 C12.3319258,9.7323301 11.6284919,10.564466 11.3190255,11.3694175 C11.2061717,11.6571845 11.177123,12.0577184 11.177123,12.460534 L11.177123,19.9786408 L6.89781903,19.9786408 C6.89781903,19.9786408 6.95545244,7.78033981 6.89781903,6.51650485 L11.1767053,6.51650485 L11.1767053,8.42470874 C11.1680278,8.43898058 11.1567517,8.45436893 11.1485847,8.46820388 L11.1767053,8.46820388 L11.1767053,8.42470874 C11.7451972,7.50873786 12.760464,6.20024272 15.0329466,6.20024272 C17.8483991,6.20019417 19.9590255,8.12432039 19.9590255,12.2593689 Z M2.42148492,0.0270873786 C0.957540603,0.0270873786 0,1.03160194 0,2.35257282 C0,3.64475728 0.929837587,4.67975728 2.36468677,4.67975728 L2.39327146,4.67975728 C3.88556845,4.67975728 4.81364269,3.64495146 4.81364269,2.35257282 C4.78552204,1.03160194 3.88556845,0.0270873786 2.42148492,0.0270873786 Z M0.254153132,19.9786408 L4.53183295,19.9786408 L4.53183295,6.51650485 L0.254153132,6.51650485 L0.254153132,19.9786408 Z",
    id: "LinkedIn"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.cfc3d64cf3ba3443d63c09727ca7e40f.svg";
export { ForwardRef as ReactComponent };